import React from "react";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
	MainHeaderButtonsWrapper: {
		flex: "none",
		marginLeft: "auto",
		display: "flex",
		alignItems: "center",
		flexWrap: "wrap",
		justifyContent: "flex-end",
		gap: theme.spacing(0.75),
		maxWidth: "100%",
		[theme.breakpoints.down("sm")]: {
			marginLeft: 0,
			width: "100%",
			justifyContent: "flex-start",
		},
		"& > *": {
			margin: 0,
		},
	},
}));

const MainHeaderButtonsWrapper = ({ children }) => {
	const classes = useStyles();

	return <div className={classes.MainHeaderButtonsWrapper}>{children}</div>;
};

export default MainHeaderButtonsWrapper;
